module.exports = __webpack_public_path__ + "img/bg-elements.eeef7b7d.png";